import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, VStack } from '@chakra-ui/react';

import InfiniteScrollTable from '../../../../../components/InfiniteScrollTable';
import NoResultsMessage from '../../../../../components/NoResultsMessage';
import nothingHere from '../../../../../nothing-here.png';
import { getAutomationSequences, selectAutomationSequences, selectCurrentAutomation } from '../../../../../redux/modules/emailAutomations';
import AutomationTabHeader from '../AutomationTabHeader';

import { getColumnsForResourceType } from './columns';

const AutomationHistory = () => {
  const dispatch = useDispatch();
  const currentAutomation = useSelector(selectCurrentAutomation);
  const { data, ...pageInfo } = useSelector(selectAutomationSequences);

  useEffect(() => {
    if (currentAutomation) {
      dispatch(getAutomationSequences(currentAutomation.id));
    }
  }, []);

  const columns = useMemo(
    () => currentAutomation && getColumnsForResourceType(currentAutomation),
    [currentAutomation]
  );

  if (!data || !data.length) {
    return (
      <VStack alignItems="flex-start" flex={1} maxW="600px" ml="100px" p={4} spacing={8}>
        <NoResultsMessage
          altTag="No Automation History Yet"
          image={nothingHere}
          message="No Automation History Yet"
        />
      </VStack>
    );
  }

  return (
    <Box ml={4} p={4}>
      <InfiniteScrollTable
        columns={columns}
        data={data}
        fetchMoreData={() => {}}
        hasMore={pageInfo.hasMore}
        height="400px"
      />
    </Box>
  );
};

AutomationHistory.propTypes = {};

export default AutomationHistory;
